<template lang="pug">
div.drug-search-wrap
  input.form-control(type="text" v-model="searchText" placeholder="搜尋藥物名稱" ref="input")
  Loader(v-if="showLoader")
  div.drug-search-list(v-else)
    div(
      v-if="filterDrugInDeviceList.length !== 0")
      //- drugstorage list view
      div(v-for="drug, num in filterDrugInDeviceList" v-if="viewMode === 'drugStorageList'"
          @click="selectDrug(drug)"
          :class="{ 'btn': true, 'drug-button': true, 'drug-selected': drug.selected, 'avoid-clicks': (drug.stock === 0 && currentApp.name === '一般取藥') || (drug.max_stock === drug.stock && currentApp.name === '補充藥物') }")
        div.drug-head(:style="{ width: drugItemHeadWidth }")
          div.drug-head-icon-wrap
            font-awesome-layers(class="fa-lg")
              font-awesome-icon(:icon="circleIcon" size="lg" color="orange")
              font-awesome-icon(:icon="pillBottleIcon" transform="shrink-6 right-3" color="white")
          div.drug-head--content
            span {{drug.medication.CGMH_number }} - {{ drug.medication.code }}
            p {{ drug.medication.generic_name }}
        div.drug-item
          div.info-col#posistion
            div.info-col-head
              span 位置(櫃-層-列-行)
            div.info-col-content
              p {{ drug.device.net.open_times }} - {{ drug.device.net.row_id }} - {{ drug.device.pos_row }} - {{ drug.device.relative_col }}
          div.info-col#max-amount
            div.info-col-head
              span 庫存量(最大量)
            div.info-col-content
              p {{ drug.stock }}({{drug.max_stock}})
          div.info-col#patch
            div.info-col-head
              span 批號
            div.info-col-content
              p(v-if="drug.patch_number === undefined || drug.patch_number === null || drug.patch_number === ''") 未設定
              p(v-else) {{ drug.patch_number }}
          div.info-col#expired-date
            div.info-col-head
              span 有效期限
            div.info-col-content
              p {{ drug.expired_date }}
      
      //- medication list view
      div.drug-button.btn.drug-button-by-med(v-if="viewMode === 'medList'"
          v-for="item in drugStorageByDrug"
          @click="selectDrugByMed(item)"
          :class="{ 'avoid-clicks': (item.stock === 0 && currentApp.name === '一般取藥'), 'drug-selected': item.selected }")
        div.drug-head(:style="{ width: drugItemHeadWidth }")
          div.drug-head-icon-wrap
            font-awesome-layers(class="fa-lg")
              font-awesome-icon(:icon="circleIcon" size="lg" color="red")
              font-awesome-icon(:icon="pillsIcon" transform="shrink-6 right-2" color="white")
          div.drug-head--content
            span {{ item.medication.CGMH_number}} - {{ item.medication.code }}
            p {{ item.medication.generic_name }}
        div.drug-item
          //- div.info-col
          //-   div.info-col-head
          //-     span 最近有效期限
          //-   div.info-col-content
          //-     span {{item.expired_date.format('Y-M-D')}}
          div.info-col
            div.info-col-head
              span 藥倉數量
            div.info-col-content
              span {{item.lists.length}}
          div.info-col(v-if="$store.state.currentApp.name === '補充藥物'")
            div.info-col-head
              span 可補量
            div.info-col-content
              span {{item.max_stock - item.stock}}
          div.info-col(v-else)
            div.info-col-head
              span 目前存量
            div.info-col-content
              span {{item.stock}}
      RefillToNewDrugStorage(
        v-if="showRefillToNewDrugStorage"
        v-on:refillNewDrugStorage="refillNewDrugStorage"
      )
    div(v-else)
      span  無任何資料
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { faPills, faCircle, faPrescriptionBottleAlt } from '@fortawesome/free-solid-svg-icons';
import Loader from '../common/Loader';
import RefillToNewDrugStorage from './RefillToNewDrugStorage';


export default {
  name: 'DrugInDeviceList',
  props: {
    mode: {
      type: String,
      default: '',
    },
    singleSelection: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: String,
      default: 'drugStorageList', // drugStorageList, medList
    },
    medSelectMode: {
      type: String,
      default: 'automatic',
    },
    showRefillToNewDrugStorage: {
      type: Boolean,
      default: false,
    },
    drugItemHeadWidth: {
      type: String,
      default: '40%',
    },
  },
  data() {
    return {
      searchText: '',
      showLoader: false,
    };
  },
  components: {
    Loader,
    RefillToNewDrugStorage,
  },
  async created() {
    // this.showLoader = true;
    // this.showLoader = false;
  },
  computed: {
    filterDrugInDeviceList() {
      return this.$store.state.drugInDevice.filterDrugInDeviceList;
    },
    currentApp() {
      return this.$store.state.currentApp;
    },
    instance() {
      return this.$store.state.instance;
    },
    pillsIcon() {
      return faPills;
    },
    circleIcon() {
      return faCircle;
    },
    pillBottleIcon() {
      return faPrescriptionBottleAlt;
    },
    allDevices() {
      return this.$store.state.device.allDevices;
    },
    drugStorageByDrug() {
      const byDrug = {};
      this.filterDrugInDeviceList.forEach((item) => {
        if (byDrug[item.medication.id] === undefined) {
          byDrug[item.medication.id] = {};
          byDrug[item.medication.id].selected = false;
          byDrug[item.medication.id].medication = item.medication;
          byDrug[item.medication.id].stock = 0;
          byDrug[item.medication.id].max_stock = 0;
          byDrug[item.medication.id].lists = [];
          byDrug[item.medication.id].expired_date = moment(item.expired_date);
        }

        // exclude item with empty stock
        // this should only on mode with fetch app
        if (this.$store.state.currentApp.name === '一般取藥') {
          if (item.stock > 0) {
            byDrug[item.medication.id].stock += item.stock;
            byDrug[item.medication.id].max_stock += item.max_stock;
            byDrug[item.medication.id].lists.push(item);
            if (item.selected) byDrug[item.medication.id].selected = true;
            if (moment(item.expired_date).isBefore(byDrug[item.medication.id].expired_date)) {
              byDrug[item.medication.id].expired_date = moment(item.expired_date);
            }
          }
        } else {
          byDrug[item.medication.id].stock += item.stock;
          byDrug[item.medication.id].max_stock += item.max_stock;
          byDrug[item.medication.id].lists.push(item);
          if (item.selected) byDrug[item.medication.id].selected = true;
          if (moment(item.expired_date).isBefore(byDrug[item.medication.id].expired_date)) {
            byDrug[item.medication.id].expired_date = moment(item.expired_date);
          }
        }
      });

      // exclude medication with none space to refill
      if (this.$store.state.currentApp.name === '補充藥物') {
        Object.values(byDrug).forEach((med) => {
          if (med.stock === med.max_stock) {
            delete byDrug[med.medication.id];
          }
        });
      }

      return Object.values(byDrug).sort((a, b) => {
        if (a.medication.CGMH_number < b.medication.CGMH_number) {
          return -1;
        }
        if (a.medication.CGMH_number > b.medication.CGMH_number) {
          return 1;
        }
        return 0;
      });
    },
  },
  methods: {
    selectDrug(drugStorage) {
      const targetIndex = _.findIndex(this.$store.state.drugInDevice.drugInDeviceList, (o) => { return o.id === drugStorage.id; });
      this.$store.dispatch('selectDrugInDevice', { num: targetIndex, singleSelection: this.singleSelection });
    },
    selectDrugByMed(med, index) {
      if (this.medSelectMode === 'automatic') {
        const drugStorageList = _.filter(med.lists, (o) => { return o.stock > 0; });
        // 效期近的 散裝多的 先
        //const drugStorageListSorted = _.orderBy(drugStorageList, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
        // 效期近的 散裝少的 先
        const drugStorageListSorted = _.orderBy(drugStorageList, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'asc']);
        this.selectDrug(drugStorageListSorted[0]);
      }
      if (this.medSelectMode === 'selectDrugStorage') {
        this.$emit('setDrugStorageWithSameMed', med.lists);
      }
    },
    refillNewDrugStorage() {
      // refill to a new empty device and create a new drugStorage
      const devicesList = Object.values(this.allDevices);
      const targetDeviceIndex = devicesList.findIndex((o) => { return o.drugstorage_set.length === 0 && !(o.adc_type === 'A' && o.pos_row === 0); });
      if (targetDeviceIndex === -1) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '無可使用的空藥盒，請聯絡管理人員處理。',
        });
      } else {
        this.$emit('setNewDeviceForRefill', devicesList[targetDeviceIndex].id);
      }
    },
  },
  mounted() {
    this.$refs.input.focus();
  },
  watch: {
    searchText(val) {
      this.$store.commit('FILTER_DRUG_IN_DEVICE', { mode: this.mode, searchText: val });
    },
    mode(val) {
      this.$store.commit('FILTER_DRUG_IN_DEVICE', { mode: val, searchText: this.searchText });
    },
  },
};
</script>

<style lang="sass" scoped>
.avoid-clicks
  pointer-events: none;
  box-shadow: none;
  border-style: unset

.drug-item
  width: 60%
  white-space: normal
  text-align: right
//   display: flex;
//   justify-content: flex-end;
//   align-items: center;
</style>




// WEBPACK FOOTER //
// DrugInDeviceList.vue?2d788582